var map = {
	"./backend_integration.jpg": 909,
	"./can_master_kicad_small.jpg": 357,
	"./canmaster_pcb_small.jpg": 734,
	"./hardware_support.png": 693,
	"./industrial_design.jpg": 399,
	"./manufacturing.jpg": 789,
	"./mechanical_design.png": 731,
	"./number_line.png": 845,
	"./product_specification.png": 332,
	"./uart_c_dark_small.jpg": 702
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 384;